import { render, staticRenderFns } from "./repairtype.vue?vue&type=template&id=477b5f05&"
import script from "./repairtype.vue?vue&type=script&lang=js&"
export * from "./repairtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports